import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// zh-CN translations
import zhCommon from './locales/zh-CN/common.json'
import zhNavbar from './locales/zh-CN/navbar.json'
import zhLayout from './locales/zh-CN/layout.json'
import zhLanding from './locales/zh-CN/landing.json'
import zhPricing from './locales/zh-CN/pricing.json'
import zhSkills from './locales/zh-CN/skills.json'
import zhAuth from './locales/zh-CN/auth.json'
import zhDashboard from './locales/zh-CN/dashboard.json'
import zhVoiceDesign from './locales/zh-CN/voiceDesign.json'
import zhVoiceClone from './locales/zh-CN/voiceClone.json'
import zhTranscribe from './locales/zh-CN/transcribe.json'
import zhProfile from './locales/zh-CN/profile.json'
import zhAdmin from './locales/zh-CN/admin.json'

// en translations
import enCommon from './locales/en/common.json'
import enNavbar from './locales/en/navbar.json'
import enLayout from './locales/en/layout.json'
import enLanding from './locales/en/landing.json'
import enPricing from './locales/en/pricing.json'
import enSkills from './locales/en/skills.json'
import enAuth from './locales/en/auth.json'
import enDashboard from './locales/en/dashboard.json'
import enVoiceDesign from './locales/en/voiceDesign.json'
import enVoiceClone from './locales/en/voiceClone.json'
import enTranscribe from './locales/en/transcribe.json'
import enProfile from './locales/en/profile.json'
import enAdmin from './locales/en/admin.json'

const savedLanguage = localStorage.getItem('myaigc-language') || 'zh-CN'

i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': {
      common: zhCommon,
      navbar: zhNavbar,
      layout: zhLayout,
      landing: zhLanding,
      pricing: zhPricing,
      skills: zhSkills,
      auth: zhAuth,
      dashboard: zhDashboard,
      voiceDesign: zhVoiceDesign,
      voiceClone: zhVoiceClone,
      transcribe: zhTranscribe,
      profile: zhProfile,
      admin: zhAdmin,
    },
    en: {
      common: enCommon,
      navbar: enNavbar,
      layout: enLayout,
      landing: enLanding,
      pricing: enPricing,
      skills: enSkills,
      auth: enAuth,
      dashboard: enDashboard,
      voiceDesign: enVoiceDesign,
      voiceClone: enVoiceClone,
      transcribe: enTranscribe,
      profile: enProfile,
      admin: enAdmin,
    },
  },
  lng: savedLanguage,
  fallbackLng: 'zh-CN',
  interpolation: {
    escapeValue: false,
  },
})

document.documentElement.lang = i18n.language
document.title = i18n.t('common:siteTitle')

export default i18n
